import { useCallback, useEffect, useState } from "react";
import { fetchMonitoringHomeData } from "../api/monitoringApi";

/**
 * Fetches the whole Monitoring tab's data once per (customerId, userId) —
 * everything downstream (selector bar, summary card, chart, insights,
 * reporting) reads from this one response and derives its own view state
 * client-side. See MONITORING_HOMEPAGE_RESPONSE_FIX_SPEC.md for the shape.
 */
export default function useMonitoringHomeData({ customerId, userId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!customerId || !userId) return;
    setLoading(true);
    setError(null);
    try {
      const result = await fetchMonitoringHomeData({ customerId, userId });
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [customerId, userId]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, refresh: load };
}
